import ThumbnailImage from "../../../components-new/Thumbnail";

type NotebookCardOwnerAvatarProps = {
    ownerId: number;
    currentUserId: number;
    profileImageS3Key: string | null | undefined;
    userName: string | null | undefined;
};

export function NotebookCardOwnerAvatar({
    ownerId,
    currentUserId,
    profileImageS3Key,
    userName,
}: NotebookCardOwnerAvatarProps) {
    const initial = (userName?.trim()?.charAt(0) || "?").toUpperCase();

    if (ownerId === currentUserId && profileImageS3Key) {
        return (
            <ThumbnailImage
                s3Key={profileImageS3Key}
                bucket="urn-assets"
                width={28}
                height={28}
                className="h-7 w-7 rounded-full border-2 border-white object-cover"
            />
        );
    }

    return (
        <div
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-white bg-gradient-to-br from-indigo-500 to-purple-600 text-[11px] font-bold text-white"
            title={userName || `User ${ownerId}`}
            aria-label={userName || `User ${ownerId}`}
        >
            {initial}
        </div>
    );
}
